<template>
  <b-modal
    id="modal-multi-3"
    size="sm"
    title="Confirmación"
    ok-only
    ok-title="Accept"
    v-model="$store.state.someVariables.showConfirmacionArbitro"
  >
    <b-card-text v-if="action == 'delete'" class="my-1">
      El arbitro será desactivado.
      <br />
      ¿ Deseas continuar ?
    </b-card-text>
    <template #modal-footer>
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="outline-primary"
        class="float-right mr-1"
        @click="close"
      >
        Cancelar
      </b-button>
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="primary"
        class="float-right"
        @click="saveAccion"
      >
        Aceptar
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { BModal, BCardText, BButton } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import apiCall from '../../utils/apiCall'
import {
  URL,
  //   USER,
  //   ROLES,
  //   ESTADO_JUGADOR,
  //   INSERT_DATA_PLAYER,
  //   INSERT_DATA_HISTORY_PLAYER,
  //   UPDATE_DATA_PLAYER,
} from '../../utils/variables'

export default {
  components: {
    BModal,
    BCardText,
    BButton,
  },
  directives: {
    // 'b-popover': VBPopover,
    // heightFade,
    Ripple,
  },
  props: {
    arbitroSelected: Object,
    action: String,
  },
  setup(props, { emit }) {
    const { postApi } = apiCall()

    async function deleteArbitro() {
      // console.log(props.arbitroSelected)
      const path = 'ApiArbitros/desactivateArbitro/d'
      // console.log(props.playerSelected)
      const dataSend = {
        idArbitro: props.arbitroSelected.id_arbitro,
      }
      const response = await postApi(URL, path, dataSend)
      if (response.flag === 'si') {
        // console.log('eliminado')
        emit('eliminado', props.arbitroSelected)
        store.commit(
          'someVariables/UPDATE_SHOW_CONFIRMACION_ARBITRO',
          // eslint-disable-next-line
          false
        )
      }
    }

    function saveAccion() {
      if (props.action === 'delete') {
        deleteArbitro()
      }
    }

    function close() {
      store.commit(
        'someVariables/UPDATE_SHOW_CONFIRMACION_ARBITRO',
        // eslint-disable-next-line
        false
      )
    }
    return {
      deleteArbitro,
      close,
      saveAccion,
    }
  },
}
</script>
